<h2 mat-dialog-title class="tt-secondary-background" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" cdkDragHandle style="color: white">
    <span style="width: 100%; display: inline-flex; justify-content: space-between; align-items: center">
        <span>
            {{ heading }}
        </span>
        <button style="background: transparent; border: none; margin: none; outline: none; padding: none; color: white" (click)="dialogRef.close()"><span class="far fa-times"></span></button>
    </span>
</h2>
<mat-dialog-content style="max-height: none">
    <tt-document-viewer-legacy *ngIf="!!fileItem" [ttModel]="fileItem" [ttIsEmail]="isEmail" ttEmailUserSenderFallback="true" ttEmailShowSentData="true"></tt-document-viewer-legacy>
</mat-dialog-content>
